import { TextField } from "@mui/material";
import { useOrdersContext } from "../../../context/subscription/orders/OrdersContext";
import Loading from "../../../components/loader/Loading";

const DiscountForm = () => {
    const { handleGetReceiptId, isLoading, discountCode, setDiscountCode } = useOrdersContext()
    return (
        <form
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: "10px",
                width: "100%"
            }}
            onSubmit={(e) => {
                e.preventDefault();
                handleGetReceiptId();
            }}
        >
            <TextField
                sx={{
                    width: {
                        xs: "100%",   // موبایل
                        md: "300px",  // دسکتاپ و بالاتر
                    }
                }}
                variant="outlined"
                value={discountCode}
                onChange={(e) => setDiscountCode(e.target.value)}
                placeholder="کد تخفیف"
            />

            <button
                type="submit"
                className="btn btn-blue"
                style={{
                    width: "80px",
                    whiteSpace: "nowrap"
                }}
            >
                {isLoading.discountApply ? <Loading color="#fff" /> : "اعمال"}
            </button>
        </form>

    )
}

export default DiscountForm